'use strict';

/**
 *
 * @name: RootConfig
 *
 */

import RootTemplate from './root.index.html';

function RootConfig(APP_CONSTANTS, $stateProvider, $urlRouterProvider) {

  'ngInject';
  
  $stateProvider
    .state('main', {
      abstract: true,
      url: '/',
      template: RootTemplate,
      controller: 'RootController',
      resolve: {
        resolvedUser: function($rootScope, $q) {

          var deferred = $q.defer();

          if ($rootScope.profile || $rootScope.profile === false) {

            deferred.resolve($rootScope.profile);
          } else {

            $rootScope.$watch('profile', function(newVal) {

              if (typeof newVal !== 'undefined') {

                deferred.resolve(newVal);
              }
            });
          }
          return deferred.promise;
        },
        resolvedLocalPlaylist: function(localPlaylist, $q, $rootScope) {

          var deferred = $q.defer();

          function createIdList() {

            var tempArr = [];
            $rootScope.playlist.items.forEach(function(item) {

              var postId = parseInt(item.post.id, 10);
              tempArr.push(postId);
            });
            $rootScope.playlist.idList = tempArr;
          }

          function runAndCreateInnerWatcher() {

            createIdList();

            $rootScope.$watch('playlist.items.length', function(newVal) {

              if (!isNaN(newVal)) {

                createIdList();
              }

              setTimeout(function() {

                $rootScope.$apply();
              });
            });
          }

          function setPlaylist(isUserSet) {

            if (isUserSet) {

              var playlistEarlyWatcher = $rootScope.$watch('playlist', function() {

                if ($rootScope.playlist && $rootScope.playlist.items && !isNaN($rootScope.playlist.items.length)) {

                  playlistEarlyWatcher();
                  runAndCreateInnerWatcher();
                  deferred.resolve($rootScope.playlist);
                }
              });
            } else {

              localPlaylist.getCurrentPlaylist().then(function(res) {

                runAndCreateInnerWatcher();

                deferred.resolve(res);
              }, function(err) {

                deferred.reject(err);
              });
            }
          }

          if ($rootScope.profile === false) {

            setPlaylist();
          } else if (typeof $rootScope.profile === 'object' && $rootScope.profile !== null) {

            setPlaylist(true);
          } else {

            var primWatch = $rootScope.$watch('profile', function() {

              if ($rootScope.profile === false || typeof $rootScope.profile === 'object') {

                primWatch();
                setPlaylist($rootScope.profile);
              }
            });
          }

          return deferred.promise;
        },
        RegisterFacebookBundle: function ($ocLazyLoad, $rootScope) {

          if($rootScope.lang !== 'zh-cn'){
            return $ocLazyLoad.load('RegisterFacebookBundle');
          }
        }
      }
    });

  $urlRouterProvider.otherwise('/');
}

export default RootConfig;



// WEBPACK FOOTER //
// ./app/pages/root/root.config.js